<template>
<div class="chapter">
<div class="inner_page">
<p class="fmh" id="spell"><a href="#/xhtml/contents#c_Not"><span class="epub-b">Note on Spelling</span></a></p>
<p class="tni">Since the time of the Crimean War there have been changes in the spelling of Russian names and place names. Where these have been used in extracts from contemporary papers the mid-nineteenth usage has been kept, otherwise a modern spelling has been preferred. This refers in particular to Sevastopol (Sebastopol), Balaklava (Balaclava), Kronstadt (Cronstadt), Malakov (Malakoff), Orlov (Orloff), Gorchakov (Gorchakoff) and Kornilov (Korniloff).</p>
</div>
</div>
</template>
<script>

export default {
  name: 'chapter',
  data() {
    return {}
    },
      components: {
    }
  }
</script>



// WEBPACK FOOTER //
// spell.vue?21db8fe4